import { put, takeLeading } from 'redux-saga/effects';

import socialOrganizationFeedbackApi from 'api/socialOrganizationFeedbackApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_SOCIAL_ORGANIZATION_FEEDBACKS,
  GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED,
  GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
} from './actionTypes';

function* getSocialOrganizationFeedbacks({ payload }) {
  try {
    const response = yield socialOrganizationFeedbackApi.getSocialOrganizationFeedbacks(payload);

    yield put({
      type: GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED,
    });
  }
}

function* getSocialOrganizationFeedbackDetail({ payload }) {
  try {
    const id = typeof payload === 'string' ? payload : payload?.id || payload?._id;
    const response = yield socialOrganizationFeedbackApi.getSocialOrganizationFeedbackDetail(id);

    const detail = response.payload || response.data || response;

    yield put({
      type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS,
      payload: detail,
    });

    if (payload && typeof payload.callback === 'function') {
      payload.callback(detail);
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED,
    });
  }
}

function* updateSocialOrganizationFeedback({ payload }) {
  const { id, values, callback } = payload || {};
  try {
    const feedbackId = id || payload?._id || payload?.id;
    const body = values || {
      status: payload?.status,
      response: payload?.response,
    };

    const response = yield socialOrganizationFeedbackApi.updateSocialOrganizationFeedback(
      feedbackId,
      body,
    );

    showSuccess('Cập nhật trạng thái phản ánh thành công');

    yield put({
      type: UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
      payload: response.payload || response,
    });

    if (feedbackId) {
      yield put({
        type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
        payload: feedbackId,
      });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
    });
  }
}

function* resolveSocialOrganizationFeedback({ payload }) {
  const { id, values, callback } = payload || {};
  try {
    const response = yield socialOrganizationFeedbackApi.resolveSocialOrganizationFeedback(
      id,
      values,
    );

    showSuccess('Tiếp nhận & xử lý phản ánh thành công');

    yield put({
      type: RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
      payload: response.payload || response,
    });

    if (id) {
      yield put({
        type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
        payload: id,
      });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
    });
  }
}

function* rejectSocialOrganizationFeedback({ payload }) {
  const { id, values, callback } = payload || {};
  try {
    const response = yield socialOrganizationFeedbackApi.rejectSocialOrganizationFeedback(
      id,
      values,
    );

    showSuccess('Từ chối phản ánh thành công');

    yield put({
      type: REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
      payload: response.payload || response,
    });

    if (id) {
      yield put({
        type: GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
        payload: id,
      });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
    });
  }
}

export default function* managerTcxhFeedbackSaga() {
  yield takeLeading(GET_SOCIAL_ORGANIZATION_FEEDBACKS, getSocialOrganizationFeedbacks);
  yield takeLeading(GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL, getSocialOrganizationFeedbackDetail);
  yield takeLeading(UPDATE_SOCIAL_ORGANIZATION_FEEDBACK, updateSocialOrganizationFeedback);
  yield takeLeading(RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK, resolveSocialOrganizationFeedback);
  yield takeLeading(REJECT_SOCIAL_ORGANIZATION_FEEDBACK, rejectSocialOrganizationFeedback);
}
